/**
 * ServiceIcon - branded 4-icon set for ImmoScope.
 * Uses the pre-cropped raster icons from /public/brand.
 *
 * Usage:
 *   <ServiceIcon name="market" size={48} />
 *   <ServiceIcon name="valuation" size={64} label />
 */

const ICONS = {
  market:     { src: "/brand/icon-market-analysis.png",     label: "Market Analysis",     tag: "01" },
  valuation:  { src: "/brand/icon-property-valuation.png",  label: "Property Valuation",  tag: "02" },
  insights:   { src: "/brand/icon-data-insights.png",       label: "Data Insights",       tag: "03" },
  tracking:   { src: "/brand/icon-investment-tracking.png", label: "Investment Tracking", tag: "04" },
};

export default function ServiceIcon({ name, size = 48, className = "", withGlow = false, testId }) {
  const cfg = ICONS[name];
  if (!cfg) return null;
  return (
    <img
      src={cfg.src}
      alt={cfg.label}
      width={size}
      height={size}
      className={`object-contain ${withGlow ? "drop-shadow-[0_0_18px_rgba(163,230,53,0.25)]" : ""} ${className}`}
      style={{ width: size, height: size }}
      data-testid={testId || `service-icon-${name}`}
    />
  );
}

export function ServiceIconTile({ name, title, subtitle, active = false, className = "" }) {
  const cfg = ICONS[name];
  if (!cfg) return null;
  return (
    <div
      className={`relative border transition-all ${
        active
          ? "border-lime-400/60 bg-lime-400/[0.03]"
          : "border-white/10 bg-zinc-900/40 hover:border-lime-400/40 hover:bg-zinc-900/70"
      } ${className}`}
      data-testid={`service-tile-${name}`}
    >
      <div className="absolute top-3 left-3 font-mono-data text-[10px] text-lime-400 tracking-widest">
        {cfg.tag}
      </div>
      <div className="flex items-center justify-center p-6 pb-3">
        <ServiceIcon name={name} size={88} />
      </div>
      <div className="px-4 pb-4 text-center border-t border-white/5 pt-3">
        <div className="font-display font-black text-sm tracking-wide text-zinc-50">{title}</div>
        {subtitle && <div className="text-[11px] text-zinc-500 mt-1 leading-relaxed">{subtitle}</div>}
      </div>
    </div>
  );
}

export function ServiceIconHeader({ name, kicker, title, subtitle }) {
  return (
    <div className="flex items-center gap-4">
      <ServiceIcon name={name} size={64} withGlow />
      <div>
        <div className="font-mono-data text-xs text-lime-400 tracking-widest mb-1">— {kicker}</div>
        <h1 className="font-display font-black text-2xl md:text-3xl text-zinc-50 leading-tight">{title}</h1>
        {subtitle && <p className="text-sm text-zinc-400 mt-1.5 max-w-2xl">{subtitle}</p>}
      </div>
    </div>
  );
}
